module.exports = __webpack_public_path__ + "static/victor-hartwell-3e6b06f453e531eb7406d58179917ca1.webp";